





























































































































import Vue from "vue";
import { authentication } from "@/stores";
import { Route } from "vue-router";
import { ShopUser } from "@/models";
import { firestore } from "firebase/app";
import firebaseProject from "@/common/firebaseProject";
import { Collection, Document, List, DocDataRef } from "@/stores";
import { alert, confirm } from "@/services/dialog";
import { form, autoclose, shopBase } from "@/mixins";
import {
  createUser,
  updateUser,
  getUser,
  updatePassword,
  deleteUser
} from "@/stores/userUtil";
import dayjs from "dayjs";

const db = firebaseProject.firestore();

export default shopBase.extend(Vue).extend({
  name: "UserDetail",
  mixins: [form, autoclose],
  created() {
    const uid = this.$route.params.id;
    if (uid) {
      this.uid = uid;
      const doc = this.users?.doc(uid);
      if (doc) {
        doc.ref?.get().then(snapshot => {
          const shopUser = snapshot.data();
          if (shopUser) {
            this.userName = shopUser.userName;
            getUser(uid).then(userInfo => {
              this.email = userInfo.user?.email || "";
            });
          }
        });
      }
    }
  },
  data() {
    return {
      authentication,
      transitionName: "",
      email: "",
      confirmEmail: "",
      password: "",
      confirmPassword: "",
      userName: "",
      uid: "",
      modal_on: false,
      showPassword: false
    };
  },
  computed: {
    users(): Collection<ShopUser> {
      return new Collection(
        db.collection("shopUser") as firestore.CollectionReference<ShopUser>
      );
    },
    pageTitle(): string {
      return this.$route.params.id ? "アカウント設定" : "アカウント新規登録";
    },
    isNew(): boolean {
      return !this.$route.params.id;
    }
  },
  methods: {
    async register() {
      const email = this.email;
      const password = this.password;
      const userName = this.userName;
      const uid = this.$route.params.id;
      if (this.isNew) {
        const result = await createUser({
          email: email,
          password: password,
          userName: this.userName,
          shopId: this.shopId
        }).catch(result => {
          alert({
            title: "エラー",
            text: result.statusText
          });
          return;
        });
        if (result) this.$router.push("/user");
      } else {
        const result = await updateUser(uid, {
          email: email,
          userName: userName,
          shopId: this.shopId
        }).catch(result => {
          alert({
            title: "エラー",
            text: result.statusText
          });
        });
        if (result) this.$router.push("/user");
      }
    },
    editPassword() {
      this.modal_on = true;
    },
    async registerNewPassword() {
      debugger;
      const password = this.password;
      const uid = this.$route.params.id;
      const result = await updatePassword(uid, password).catch(result => {
        alert({
          title: "エラー",
          text: result.statusText
        });
      });
      if (result) this.modal_on = false;
    },
    async deleteUser() {
      const result = await confirm({
        title: "確認",
        text:
          "このユーザーを削除します。（この操作は取り消せません）\nよろしいですか？"
      });
      if (result) {
        const result = await deleteUser(this.uid).catch(result => {
          alert({
            title: "エラー",
            text: "ユーザーの削除に失敗しました。"
          });
        });
        if (result) this.$router.push("/user");
      }
    }
  },
  watch: {}
});
